export default "<template>\n    <section>\n        <o-timepicker inline />\n    </section>\n</template>\n"